import { inject, Injectable } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';
import { TimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import { KlaviyoTrackingService } from '../../klaviyo-tracking.service';

/**
 * Klaviyo login event trigger
 * Tracks when a customer logs in to their account
 */
@Injectable({
    providedIn: 'root'
})
export class KlaviyoEventLoginTrigger {
    static readonly EVENT_NAME = 'Customer Logged In';
    static readonly EVENT_PROPERTY_LAST_LOGIN_DATE = 'last log in date';

    /**
     * Klaviyo tracking service
     */
    private klaviyoTrackingService = inject(KlaviyoTrackingService);

    /**
     * Customer model service
     */
    private customerModel = inject(CustomerModel);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Timeout service
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'nexusCheckoutLogin' || event.id === 'nexusCustomerLogin') {
                this.timeoutService.setTimeout(() => {
                    if (this.customerModel.isLoggedIn) {
                        this.dispatch();
                    }
                }, 100);
            }
        });
    }

    /**
     * Dispatch event to Klaviyo
     */
    private dispatch() {
        this.klaviyoTrackingService.track(KlaviyoEventLoginTrigger.EVENT_NAME, this.trackData());
    }

    protected trackData() {
        const currentTimestamp = new Date().toISOString();
        return { [KlaviyoEventLoginTrigger.EVENT_PROPERTY_LAST_LOGIN_DATE]: currentTimestamp };
    }
}
